import SummaryType from "state/selections/Constants/SummaryType";
import scope from "./scope";

export default class IssuerCountDefinition {
  static getDefault = () =>
    new IssuerCountDefinition({
      issuerCountType: "Default",
      summary: SummaryType.ABSOLUTE,
    });

  #issuerCountType;
  #summary;

  constructor({ issuerCountType, summary }) {
    this.#issuerCountType = issuerCountType;
    this.#summary = summary;
  }

  get issuerCountType() {
    return this.#issuerCountType;
  }

  get summary() {
    return this.#summary;
  }

  get complete() {
    return true;
  }

  setIssuerCountType = (value) =>
    new IssuerCountDefinition({
      ...this.copy(),
      issuerCountType: value,
    });

  setSummary = (value) =>
    new IssuerCountDefinition({
      ...this.copy(),
      summary: value,
    });

  get key() {
    return `${scope} - ${this.issuerCountType}, ${this.summary}`;
  }

  copy = () => {
    return {
      issuerCountType: this.issuerCountType,
      summary: this.summary,
    };
  };
}
